import React, { FC } from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import useAPILoading from '../hooks/useLoading';
import loading_gif from '../assets/loader.gif';
import { HostProvider } from '../utils/HostProvider';

const LoadingMessage: FC = () => {
  const { promiseInProgress } = usePromiseTracker();
  const { apiLoading } = useAPILoading();
  const isEroski = HostProvider.isEroski();

  if (isEroski) {
    return (
      <>
        {(promiseInProgress || apiLoading) && (
          <div className="modal modal--small is-active loading">
            <img src={loading_gif} alt="loading" />
          </div>
        )}
      </>
    );
  }
  return (
    <>
      {(promiseInProgress || apiLoading) && (
        <div className="modal modal--small is-active loading">
          <table width="100%">
            <tbody>
              <tr>
                <td align="center">
                  <table
                    width="12"
                    style={{
                      backgroundColor: 'transparent',
                      verticalAlign: 'middle',
                    }}
                  >
                    <tbody>
                      <tr>
                        <td align="center" valign="middle">
                          <div className="loadingio-spinner-ellipsis-67v22lmz1ox">
                            <div className="ldio-a2wy07l7gtu">
                              <div />
                              <div />
                              <div />
                              <div />
                              <div />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};
export default LoadingMessage;
